import React, { Fragment, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import { Link } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { removeFromWishList, addToCart } from "../../store/actions/action";
import { Tooltip } from "react-tooltip";
import DeleteIcon from "../../icons/DeleteIcon";
import { useLoginModal } from "../../Context/LoginModalContext";
import { checkLoggedIn } from "../../utils";
import { PulseLoader } from "react-spinners";
import axios from "axios";
import { Autocomplete, TextField, Avatar, Box, Typography } from "@mui/material";
import Select from "react-select";
import CountrySelect from "../../components/CountrySelectTag/CountrySelectTag";
import "./mobile-recharge.css";

import MobileRechargePagebgimg from "./mobilerecharge.png";
import Howtomobilerechargeimage1 from "./how-mobile-rechare-1.png";
import Howtomobilerechargeimage2 from "./how-mobile-rechare-2.png";
import Howtomobilerechargeimage3 from "./how-mobile-rechare-3.png";
import Howtomobilerechargeimage4 from "./how-mobile-rechare-4.png";

const MobileRechargePage = (props) => {
  const [loading, setLoading] = useState(false);
  const [countrylist, setCountrylist] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState(null);

  const [providerLoading, setProviderLoading] = useState(false);

  // const [selectedCountry, setSelectedCountry] = useState([{
  //   _id: "662108759804587926f810a9",
  //   iso_code: "AFG",
  //   country_name: "Afghanistan",
  //   is_active: true,
  //   createdAt: "2024-04-18T11:48:05.259Z",
  //   updatedAt: "2024-09-20T16:53:27.205Z",
  //   flag_icon: "AF",
  // }]);

  const fetchLatestProducts = () => {
    setLoading(true);

    axios
      .get("sim/get-country-list", {
        params: { latestproducts: true },
      })
      .then((response) => {
        const data = response?.data?.data;
        setCountrylist(data);
      })
      .catch((error) => {
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchProvider = () => {
    setProviderLoading(true);

    axios
      .get("sim/get-country-provider", {
        params: { iso: selectedCountry?.iso_code },
      })
      .then((response) => {
        const data = response?.data?.data;
        setSelectedProvider(data);
      })
      .catch((error) => {
        setProviderLoading(false);
      })
      .finally(() => {
        setProviderLoading(false);
      });
  };

  useEffect(() => {
    fetchLatestProducts();
  }, []);
  useEffect(() => {
    if (selectedCountry) {
      fetchProvider();
    }
  }, [selectedCountry]);

  return (
    <Fragment>
      <Navbar />
      {/* <PageTitle pageTitle={"Wishlist"} pagesub={"Wishlist"} /> */}
      <div className="main-rechate-outer">
        <div className="maindiv-mobile-recharge">
          <div>
            <h4>Send Mobile Recharges </h4>
            <h1>Worldwide </h1>
            <p> Instant data & credit delivery worldwide</p>
          </div>
        </div>

        <section className="country-selection-provider">
          <h4>Select Country </h4>
          <div className="selectcountry-model">
            {countrylist.length > 0 && <CountrySelect setSelectedCountry={setSelectedCountry} selectedCountry={selectedCountry} countrylist={countrylist} />}
          </div>
          <p>Popular Mobile recharge products in {selectedCountry?.country_name}:</p>

          <div className="operator-main-div-outer">
            {providerLoading ? (
              "loading"
            ) : (
              <div className="operator-main-div">
                {selectedProvider?.map((iteam, i) => (
                  <div key={i}>
                    <Link to={"/recharge-operater/" + iteam?.slug}>
                      <img src={iteam?.operator_image} alt={iteam?.operator_title} />
                      <div className="name-operater">{iteam?.operator_title}</div>{" "}
                    </Link>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        <div className="how-to-recharge-main-div">
          <div className="mobile-rechage-glow-bottom-right"></div>
          <div className="mobile-rechage-glow-top-right"></div>
          <div className="mobile-rechage-glow-top-left"></div>
          <div className="mobile-rechage-glow-bottom-left"></div>
          <div className="mobile-rechage-shape-left-top"></div>
          <div className="mobile-rechage-shape-left-bottom"></div>

          <div className="how-to-recharge-div">
            <h2>How To Recharge?</h2>

            <div className="mobie-recharge-choose">
              <div>
                <div>
                  <h4>Step 1: Choose provider</h4>
                  <p className="text-white">Select from various mobile network operators & recharge from anywhere</p>
                </div>
              </div>
              <div>
                <img src={Howtomobilerechargeimage1} alt="how to mobile recharge image" />
              </div>
            </div>

            <div className="mobie-recharge-choose">
              <div>
                <img src={Howtomobilerechargeimage2} alt="how to mobile recharge image" />
              </div>

              <div>
                <div>
                  <h4>Step 2: Pick a recharge & fill in number</h4>
                  <p className="text-white">Choose recharge option and enter recipient's phone number</p>
                </div>
              </div>
            </div>

            <div className="mobie-recharge-choose">
              <div>
                <div>
                  <h4>Step 3: Pay with preferred method</h4>
                  <p className="text-white">We offer a range of secure payment options to suit your needs</p>
                </div>
              </div>
              <div>
                <img src={Howtomobilerechargeimage3} alt="how to mobile recharge image" />
              </div>
            </div>

            <div className="mobie-recharge-choose">
              <div>
                <img src={Howtomobilerechargeimage4} alt="how to mobile recharge image" />
              </div>

              <div>
                <div>
                  <h4>Step 4: Enjoy - You're all set!</h4>
                  <p className="text-white">Ones the payment is confirmed, the account will be recharged immediately</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="how-to-mobile-recharge-description">

        <div className="mobile-rechage-glow-top-left-last"></div>
        <div className="mobile-rechage-shape-left-bottom-last"></div>

          <div className="how-to-mobile-recharge-description-text">
            <div>
              <h4>What is a mobile recharge?</h4>
              <p>
              Mobile recharge is your phone's ultimate lifeline, keeping it alive and kicking! Think of it as the prepaid voucher for your mobile phone account, empowering you to top up your mobile balance effortlessly. You can make calls, send texts, and surf the web without interruptions. Whether chatting with loved ones or scrolling through your favorite social media feeds, mobile recharge ensures you stay connected, no matter where you are. Buy a mobile top-up now and experience uninterrupted conversations, unlimited texting, and limitless internet browsing. Embrace the power of mobile recharge and stay connected with ease!
              </p>
            </div>

            <div>
              <h4>What is mobile airtime recharge?</h4>
              <p>
              Mobile airtime recharge is the hassle-free method of adding credit or balance to a prepaid mobile phone account. It's an easy way to extend your talk time and text messaging on your mobile device. When you recharge your mobile airtime, you simply purchase a specific amount of credit, which gets added directly to your mobile account. With mobile airtime recharge, you're empowered to keep your mobile services active and functional, so you can stay connected with your loved ones and make the most out of your mobile experience.
              </p>
            </div>

            <div>
              <h4>What is mobile data recharge?</h4>
              <p>
              Mobile data recharge is your passport to seamless internet access on your mobile device. It's a straightforward, user-friendly method of adding data or internet balance to your mobile phone account. When you recharge your mobile data, you're purchasing a specific data allowance that gets credited directly to your account, ready to fuel your online browsing. No more hunting for Wi-Fi or worrying about running out of data when you need it the most. With mobile data recharge, you can stay connected, stream videos, browse websites, and connect with friends on social media without a hitch.
              </p>
            </div>

          </div>
        </div>
      </div>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    w_list: state.wishList.w_list,
    carts: state.cartList.cart,
  };
};
export default connect(mapStateToProps, { removeFromWishList, addToCart })(MobileRechargePage);
